<app-header></app-header>
<div class="title"></div>
<div class="margin-top-70">
  <div class="container">
    <div class="row">
      <div class="mx-auto col-md-6 mt-6">
        
      </div>
      <div class="mx-auto col-md-6 mt-6">
        
      </div>
    </div>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
  </div>
</div>

<div class="container">
  <div class="" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Source Product Id</th>
          <th scope="col">Source Product ISBN</th>
          <th scope="col">Source Title Name</th>
          <th scope="col">Source Product Published Date</th>
          <th scope="col">Netsuite Id</th>
          <th scope="col">Author Name</th>
          <th scope="col">Derivative Product Id</th>
          <th scope="col">Derivative Title Name</th>
          <th scope="col">Attributed %</th>
          <th scope="col">Related Product Edition</th>
          <th scope="col">Derivative Published Date</th>
          <th scope="col">Derivative Title Status</th>
          <th scope="col">Is Derivative</th>
          <th scope="col">Contract Section(Yes/No)</th>
          <th scope="col">Number of Contracts</th>
          <th scope="col">Print Band 1</th>
          <th scope="col">Ebook Band 1</th>
          <th scope="col">Video Band 1</th>
          <th scope="col">Course Band 1</th>
          <th scope="col">Translation Band 1</th>
          <th scope="col">Packtlib band 1</th>
          <th scope="col">Third Party Band 1</th>
          <th scope="col">Audiobook Band 1</th>
          <th scope="col">Quizzes Band 1</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.source_product_id}}</td>
          <td>{{product.source_product_isbn}}</td>
          <td>{{product.source_title_name}}</td>
          <td>{{product.source_product_published_date}}</td>
          <td>{{product.netsuite_id}}</td>
          <td>{{product.author_name}}</td>
          <td>{{product.derivative_product_id}}</td>
          <td>{{product.derivative_title_name}}</td>
          <td>{{product.attributed_percentage}}</td>
          <td>{{product.related_product_edition}}</td>
          <td>{{product.derivative_published_date}}</td>
          <td>{{product.derivative_title_status}}</td>
          <td>{{product.is_derivative}}</td>
          <td>{{product.contract_session}}</td>
          <td>{{product.number_of_contracts}}</td>
          <td>{{product.print_band_1}}</td>
          <td>{{product.ebook_band_1}}</td>
          <td>{{product.video_band_1}}</td>
          <td>{{product.course_band_1}}</td>
          <td>{{product.translation_band_1}}</td>
          <td>{{product.packtlib_band_1}}</td>
          <td>{{product.third_party_band_1}}</td>
          <td>{{product.audiobook_band_1}}</td>
          <td>{{product.quizzes_band_1}}</td>
        </tr>
      </tbody>
    </table>
    <!-- Total Products {{totalProducts}} -->
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
